// extracted by mini-css-extract-plugin
export var defaultWrapper = "_iu-3";
export var downloadButton = "_iu-4";
export var fileContainer = "_iu-9 _iu-7";
export var fileContainerBase = "_iu-7";
export var fileContainerFixedHeight = "_iu-8 _iu-7";
export var fileInfo = "_iu-5";
export var fileInfoWidthRestricted = "_iu-6";
export var fileType = "_iu-1";
export var fileTypeName = "_iu-2";
export var image = "_iu-0";
export var link = "_iu-b";
export var overflowEllipsis = "_iu-a";